var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"winning-together-button"},[_c('separator'),_vm._v(" "),_c('div',{staticClass:"winning-together",on:{"click":_vm.openPopup}},[_vm._v("\nאיך לנצח את החודש הבא?\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }